export const PDP_ERROR_MESSAGE = "We're sorry but the artwork you requested does not exist."

export const ERROR_DATA = {
  title: 'Curated Deals',
  subTitlePDP: 'Oops! This masterpiece is missing',
  subTitleGeneral: 'Oops! This page is missing',
  description: `We can’t seem to find that page. The link to this page may be incorrect or out of date. Let us help you find an artwork you love.`,
}

export const TILES_DATA = [
  {
    url: '/all',
    name: 'One-Of-A-Kind-Art',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/one-of-kind-fallback.jpg',
    linkTitle: 'Explore Art',
  },
  {
    url: '/prints',
    name: 'Fine Art Prints',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/art-print-fallback.jpg',
    linkTitle: 'Explore Art Prints',
  },
  {
    url: '/quiz/art-for-your-style-quiz ',
    name: 'Find Out Your Art Style',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/art-style-fallback.jpg',
    linkTitle: 'Take Our Quiz',
  },
  {
    url: '/artadvisory',
    name: 'Complimentary Art Advisory',
    imageUrl: '//d3t95n9c6zzriw.cloudfront.net/common/art-advisory-2x-fallback.jpg',
    linkTitle: 'Get Started',
  },
]
